import { AppHeader } from '@terminal/components/app-header/AppHeader';
import { ChatInput, ChatInputProps } from '@terminal/components/chat';
import { ScenarioInsightsLegacyDrawerRender } from '@terminal/components/insights-legacy-drawer/ScenarioInsightsLegacyDrawerRender';
import { config as appConfig } from '@terminal/config';
import { useTouchDevice } from '@terminal/hooks/MediaQueryHook';
import { mobileAlfredPaths } from '@terminal/Root';
import { AppRoute } from '@terminal/routes';
import { appPaths } from '@terminal/routes/app-paths';
import { useReasonerParams } from '@terminal/views/alfred/research/hooks/useReasonerParams';
import { useChatNavigation } from '@terminal/views/alfred/use-chat-navigation/useChatNavigation';
import { MarketInsightDrawerRender } from '@terminal/views/dashboard/whats-new-widget/components/market-insight-drawer/MarketInsightDrawerRender';
import { WhatsNewSettingsDrawer } from '@terminal/views/dashboard/whats-new-widget/components/whats-new-settings-drawer/WhatsNewSettingsDrawer';
import { Widgets } from '@terminal/views/widgets/Widgets';
import { InsightDrawerShell } from '@terminal/widgets/insight-drawer-shell/InsightDrawerShell';
import { cloneElement, useEffect } from 'react';
import { useLocation } from 'react-router';
import { checkIsMobile } from '../ProtectedView';
import styles from './View.module.scss';

export interface AccountViewProps {
  config: AppRoute;
  showHeader: boolean;
}

export const View = ({ config, showHeader }: AccountViewProps) => {
  const location = useLocation();
  const isTouchDevice = useTouchDevice();

  const { navigateToConversation } = useChatNavigation();
  const { conversationId } = useReasonerParams();

  const { element } = config;

  const content = cloneElement(element, {
    renderChatInput: (props?: ChatInputProps) => <ChatInput {...props} />,
  });

  const isMobileAlfredPath =
    mobileAlfredPaths.includes(location.pathname) && isTouchDevice;

  useEffect(() => {
    if (
      !appConfig.app.isLocalEnvironment &&
      checkIsMobile() &&
      location.pathname !== appPaths.alfred &&
      location.pathname !== appPaths.alfredSettings
    ) {
      navigateToConversation(conversationId);
    }
  }, [conversationId, location.pathname]);

  return (
    <>
      {showHeader && !isMobileAlfredPath && <AppHeader />}
      <div className={styles.viewRoot} id={'root-view'}>
        {!isMobileAlfredPath && (
          <>
            <Widgets />
            <InsightDrawerShell />
            <ScenarioInsightsLegacyDrawerRender />
            <MarketInsightDrawerRender />
            <WhatsNewSettingsDrawer />
          </>
        )}
        {content}
      </div>
    </>
  );
};
